import { getIsLogged } from '../login/reducers'
import {cloneDeep} from "lodash";

export const initState = {
    currentSegmentation: 'BUSINESS_SEGMENT',
    segmentatingProductId: null,
    segmentatingProductIsOutlet: null,
    currentFavourite: null,
    segmentationSubmitted: false,
    businessSegment: null,
    channel: null,
    originalChannel: null,
    channelName: null,
    originalChannelName: null,
    subchannel: null,
    subchannelName: null,
    salesForceId: null,
    salesForceName: null,
    projectId: null,
    projectName: null,
    subchannelProgram: null,
    typology: null,
    typologyName: null,
    use: null,
    useName: null,
    segmentationOptions: [],
    nexusOptions: [],
    leadsB2COptions: [],
    materials: [],
    kb: null,
    builder: null,
    po: [],
    useOptions: [],
    typologiesV3: [],
    kbOptions: [],
    buildersOptions: [],
    isSaving: false,
    fetchingSegmentation: false,
    segmentationV3: null,
    segmentationCurrentStep: 1,
    segmentationEvidence: null,
    suggestedSegmentations: null,
    segmentationProjects: new Set(),
    segmentationHashesSet: {},
    fromCartLine: false
}

const segmentation = (state = initState, action) => {
    switch (action.type) {
        case 'SAVE_CURRENT_FAVOURITE_REQUEST':
            return Object.assign({}, state, { isSaving: true })
        case 'SAVE_CURRENT_FAVOURITE_SUCCESS':
        case 'SAVE_CURRENT_FAVOURITE_FAILURE':
            return Object.assign({}, state, { isSaving: false })
        case 'ADD_CART_LINE_SUCCESS':
        case 'ADD_CART_BULK_LOTS_SUCCESS':
            return Object.assign({}, state, { po: [] })
        case 'SET_LANGUAGE':
        case 'SIMPLE_IMPERSONATE_SUCCESS':
        case 'LOGOUT':
            return Object.assign({}, state, initState)
        case 'CHANGE_CENTER':
        case 'CLEAR_SEGMENTATION':
            return Object.assign({}, state, {
                currentFavourite: null,
                businessSegment: null,
                channel: null,
                channelName: null,
                subchannel: null,
                subchannelName: null,
                salesForceId: null,
                salesForceName: null,
                projectId: null,
                projectName: null,
                typology: null,
                typologyName: null,
                use: null,
                useName: null,
                kb: null,
                builder: null,
                po: [],
                subchannelProgram: null,
                originalChannel: null
            })
        case 'RESET_SEGMENTATION':
            return Object.assign({}, state, { segmentationSubmitted: false, segmentationEvidence: null })
        case 'SUBMIT_SEGMENTATION_REQUEST':
            return Object.assign({}, state, {})
        case 'SHOW_SEGMENTATION_MODAL':
            return Object.assign({}, state, { segmentatingProductId: action.productId, segmentatingProductIsOutlet: action.outlet, fromCartLine: action.mode === 'edit' })

        case 'SUBMIT_SEGMENTATION_SUCCESS':
            return Object.assign({}, state, { segmentationSubmitted: true, showSegmentationModal: false })
        case 'SUBMIT_SEGMENTATION_FAILURE':
            return Object.assign({}, state, { segmentationSubmitted: false, showSegmentationModal: true })
        case 'SELECT_SEGMENTATION_A':
            return Object.assign({}, state, { selectedA: action.selected })
        case 'TOGGLE_SEGMENTATION':
            if (state.currentSegmentation === action.seg) {
                return Object.assign({}, state, { currentSegmentation: null })
            }
            return Object.assign({}, state, { currentSegmentation: action.seg })
        case 'LOAD_SEGMENTATION_PREFERED_REQUEST':
            return Object.assign({}, state, {})
        case 'LOAD_SEGMENTATION_PREFERED_FAILURE':
            return Object.assign({}, state, {})
        case 'LOAD_SEGMENTATION_PREFERED_SUCCESS':
            let channelName = action.segmentation.channelName
            //TODO leadsB2COptions
            if (action.segmentation.channel.startsWith('nexus')) {
                const segmentation = state.nexusOptions[action.segmentation.channel]
                    && state.nexusOptions[action.segmentation.channel].salesforceRelations[action.segmentation.salesforceId]

                if (segmentation) {
                    channelName = segmentation.originalChannelName
                }
            }

            let channelId = action.segmentation.channel
            if (channelId === 'AP' || channelId === 'HE' || channelId === 'B0') channelId = 'PO'

            return Object.assign({}, state, {
                businessSegment: action.segmentation.businessSegment,
                currentSegmentation: null,
                channel: channelId,
                channelName: channelName,
                subchannel: action.segmentation.subchannel,
                subchannelProgram: action.segmentation.subchannelProgram,
                subchannelName: action.segmentation.subchannelName,
                salesForceId: action.segmentation.salesforceId,
                salesForceName: action.segmentation.salesforceName,
                projectId: action.segmentation.projectId,
                projectName: action.segmentation.projectName,
                typology: action.segmentation.typology,
                typologyName: action.segmentation.typologyName,
                builder: { id: action.segmentation.builderId, name: action.segmentation.builderName },
                po: action.segmentation.purchaseOrders,
                use: action.segmentation.use,
                useName: action.segmentation.useName,
                kb: state.kbOptions.find(kb => {
                    return kb.id === action.segmentation.kbId
                }),
                evidence: action.segmentation.evidence,
                originalChannel: action.segmentation.originalChannel ? action.segmentation.originalChannel : action.segmentation.channel
            })
        case 'SET_SEGMENTATION_FROM_SUGGESTED':
            const typology = state.typologiesV3.find(t => t.id === action.suggestedSegmentation.ambient)
            const use = state.useOptions.find(t => t.id === action.suggestedSegmentation.use)
            return Object.assign({}, state, {
                businessSegment: action.suggestedSegmentation.businessSegment,
                currentSegmentation: null,
                channel: action.suggestedSegmentation.channelId,
                channelName: action.suggestedSegmentation.channelName,
                subchannel: action.suggestedSegmentation.subchannel,
                subchannelProgram: action.suggestedSegmentation.subchannelProgram,
                salesForceId: action.suggestedSegmentation.id,
                salesForceName: action.suggestedSegmentation.name,
                projectId: action.suggestedSegmentation.projectId,
                projectName: action.suggestedSegmentation.projectName,
                typology: action.suggestedSegmentation.ambient,
                typologyName: typology && typology.name,
                use: action.suggestedSegmentation.use,
                useName: use && use.name,
                evidence: action.suggestedSegmentation.evidence,
                originalChannel: action.suggestedSegmentation.originalChannel
            })
        case 'SELECT_BUSINESS_SEGMENT':
            return Object.assign({}, state, {
                businessSegment: action.value,
                currentSegmentation: 'CHANNEL',
                channel: null,
                channelName: null,
                subchannel: null,
                subchannelName: null,
                typology: null,
                typologyName: null,
                builder: null,
                kb: null
            })
        case 'SELECT_CHANNEL':
            return Object.assign({}, state, {
                businessSegment: state.segmentationV3 && action.value === 'A0' ? 'RE' : state.businessSegment,
                channel: action.value,
                channelName: action.name,
                currentSegmentation: 'SUBCHANNEL',
                subchannel: state.segmentationV3 && action.value === 'A0' ? '1A' : null,
                subchannelName: null,
                typology: null,
                typologyName: null,
                use: null,
                useName: null,
                salesForceId: null,
                salesForceName: null,
                projectId: null,
                projectName: null,
                originalChannel: null,
                originalChannelName: null
            })
        case 'SELECT_SUBCHANNEL':
            return Object.assign({}, state, {
                subchannel: action.value,
                subchannelName: action.name,
                currentSegmentation: 'TYPOLOGY',
                typology: null,
                typologyName: null,
                salesForceId: null,
                salesForceName: null,
                projectId: null,
                projectName: null
            })
        case 'SELECT_SALESFORCEID':
            return Object.assign({}, state, {
                salesForceId: action.value,
                salesForceName: action.name,
                subchannelProgram: action.subchannelProgram ? action.subchannelProgram : null,
                businessSegment: action.businessSegment ? action.businessSegment : null,
                currentSegmentation: null,
                subchannel: state.channel === 'A0' ? '1A' : action.subchannelId,
                projectId: null,
                projectName: null
            })
        case 'SELECT_PROJECTID':
            return Object.assign({}, state, {
                projectId: action.value,
                projectName: action.name,
                currentSegmentation: null,
                subchannelProgram: action.subchannelProgram ? action.subchannelProgram : state.subchannelProgram,
                businessSegment: action.businessSegment ? action.businessSegment : state.businessSegment,
                subchannel: state.channel === 'A0' ? '1A' : (action.subchannelId ? action.subchannelId : state.subchannel),
                // salesForceId: state.salesForceId ? state.salesForceId : action.salesForceId,
                // salesForceName: state.salesForceName ? state.salesForceName : action.salesForceName,
                salesForceId: action.salesForceId ? action.salesForceId : state.salesForceId,
                salesForceName: action.salesForceName ? action.salesForceName : state.salesForceName,
                originalChannel: action.originalChannel,
                originalChannelName: action.originalChannelName
            })
        case 'SELECT_TYPOLOGY':
            return Object.assign({}, state, {
                typology: action.value,
                typologyName: action.name,
                currentSegmentation: null
            })
        case 'SELECT_USE':
            return Object.assign({}, state, { use: action.value, useName: action.name, currentSegmentation: null })
        case 'SELECT_KB':
            return Object.assign({}, state, { kb: action.value, currentSegmentation: null })
        case 'SELECT_BUILDER':
            return Object.assign({}, state, { builder: action.value, currentSegmentation: null })
        case 'SET_PO':
            return Object.assign({}, state, { po: action.value })
        case 'FETCH_SEGMENTATION_REQUEST':
            return Object.assign({}, state, { fetchingSegmentation: true })
        case 'SET_CURRENT_FAVOURITE':
            return Object.assign({}, state, { currentFavourite: action.currentFavourite })
        case 'FETCH_SEGMENTATION_FAILURE':
            return Object.assign({}, state, { fetchingSegmentation: false })
        case 'FETCH_SEGMENTATION_SUCCESS':
            const q = action.segmentation.segmentation
            const segmentationOptions = action.segmentationV3 ? transformByIdV3(q) : transformById(q)
            const nexusOptions = transformByIdV3(action.segmentation.nexusSegmentation, 'nexus')
            const leadsB2COptions = transformByIdV3(action.segmentation.leadsB2CSegmentation, 'leads')
            const newState = Object.assign({}, state, {
                segmentationOptions: segmentationOptions,
                nexusOptions: nexusOptions,
                leadsB2COptions: leadsB2COptions,
                materials: action.segmentation.materials || [],
                fetchingSegmentation: false,
                useOptions: action.segmentation.uses,
                kbOptions: action.segmentation.kbs,
                buildersOptions: action.segmentation.builders,
                preferredSegmentation: fillFavouriteSegmentation(action.segmentation.favourites, action.segmentationV3, segmentationOptions, action.segmentation.hashes),
                typologiesV3: action.segmentation.typologies,
                segmentationV3: action.segmentationV3,
                suggestedSegmentations: action.segmentation.suggested,
                segmentationHashesSet: action.segmentation.hashes
            })
            if (action.segmentation.hashes)  newState.segmentationProjectsSet = new Set(action.segmentation.projects)
            return newState
        case 'SET_SEGMENTATION_CURRENT_STEP':
            return Object.assign({}, state, { segmentationCurrentStep: action.segmentationCurrentStep })
        case 'SET_SEGMENTATION_EVIDENCE':
            return Object.assign({}, state, { segmentationEvidence: action.segmentationEvidence })
        default:
            return state
    }
}

const transformByIdV3 = (segmentation, specialChannel) => {
    let channels = {}
    let specialChannelRelations = {}

    if (typeof segmentation === "object") {
        segmentation = Object.entries(segmentation)

        segmentation.forEach(([key, channel]) => {

            if (channel.length === 0) return
            let salesforceRelations = {}
            const _salesforceRelations = specialChannel ? channel : channel.salesforceRelations

            _salesforceRelations.forEach(salesforceRelation => {
                let projectOptions = {}

                salesforceRelation.projectOptions.forEach((project) => {

                    projectOptions[project.projectId] = {
                        projectId: project.projectId,
                        projectName: project.projectName,
                        subchannelId: project.subchannel,
                        subchannelProgram: project.subchannelProgram,
                        evidences: project.evidences,
                        originalChannel: project.originalChannel
                    }
                })

                // if (channel.id !== 'A0' || channel.subchannel === 'SC') {
                if ((salesforceRelation.id !== '' && channel.id !== 'A0') || ((salesforceRelation.id === '' || channel.subchannel === 'SC') && channel.id === 'A0') || salesforceRelation.id !== '') {
                    const relations = {
                        name: salesforceRelation.name,
                        businessSegment: salesforceRelation.businessSegment,
                        originalChannelName: specialChannel ? salesforceRelation.channelName : null,
                        // nexusChannelId: isNexus ? salesforceRelation.channelId : null,
                        // nexusChannelName: isNexus ? salesforceRelation.channelName : null,
                        // subchannelProgram: salesforceRelation.subchannelProgram,
                        // subchannelId: salesforceRelation.subchannelId,
                        projectOptions: projectOptions
                    }

                    if (specialChannel) {
                        specialChannelRelations[salesforceRelation.id] = relations;
                    } else {
                        salesforceRelations[salesforceRelation.id] = relations;
                    }
                }
            })

            const relations = specialChannel ? specialChannelRelations : salesforceRelations

            if (Object.keys(relations).length >= 1) {
                const channelId = specialChannel ? specialChannel : channel.id;
                channels[channelId] = {
                    name: specialChannel ? getSpecialChannelName(specialChannel) : channel.name,
                    salesforceRelations: relations
                };
            }
        });
    }

    return channels;
}

const getSpecialChannelName = (key) => {
    switch (key) {
        case 'nexus':
            return 'Cosentino Nexus'
        case 'leads':
            return 'Leads B2C'
        default:
            return null
    }
}

const transformById = segmentation => {
    let byId = {}
    segmentation.forEach(businessSegment => {
        let channels = {}
        businessSegment.channels.forEach(channel => {
            let subchannels = {}
            channel.subchannels.forEach(subchannel => {
                let typologies = {}
                subchannel.typologies.forEach(typology => {
                    typologies[typology.id] = { name: typology.name }
                })
                subchannels[subchannel.id] = { name: subchannel.name, typologies }
            })
            channels[channel.id] = { name: channel.name, subchannels }
        })
        byId[businessSegment.id] = { name: businessSegment.name, channels }
    })
    return byId
}

const fillFavouriteSegmentation = (favourites, segmentationV3, channelOptions, hashes) => {
    if (segmentationV3) {
        return favourites.map(segmentation => {
            return {
                ...segmentation,
                channelName: channelOptions[segmentation.channel] && channelOptions[segmentation.channel].name,
                active: hashes[segmentation.hash] !== undefined,
                evidence: hashes[segmentation.hash]
            }
        })
    } else {
        return favourites.map(segmentation => {
            return {
                ...segmentation,
                channelName:
                    channelOptions[segmentation.businessSegment] &&
                    channelOptions[segmentation.businessSegment]['channels'] &&
                    channelOptions[segmentation.businessSegment]['channels'][segmentation.channel] &&
                    channelOptions[segmentation.businessSegment]['channels'][segmentation.channel].name,
                subchannelName:
                    channelOptions[segmentation.businessSegment] &&
                    channelOptions[segmentation.businessSegment]['channels'] &&
                    channelOptions[segmentation.businessSegment]['channels'][segmentation.channel] &&
                    channelOptions[segmentation.businessSegment]['channels'][segmentation.channel]['subchannels'] &&
                    channelOptions[segmentation.businessSegment]['channels'][segmentation.channel]['subchannels'][segmentation.subchannel] &&
                    channelOptions[segmentation.businessSegment]['channels'][segmentation.channel]['subchannels'][segmentation.subchannel].name
            }
        })
    }
}

export const getChannelOptionsV3 = state => {
    return state.segmentation.segmentationOptions
}

export const getNexusOptions = state => {
    const nexusOptions = cloneDeep(state.segmentation.nexusOptions)
    return getSpecialOptions(state, nexusOptions)
}

export const getLeadsB2COptions = state => {
    const leadsB2COptions = cloneDeep(state.segmentation.leadsB2COptions)
    return getSpecialOptions(state, leadsB2COptions)
}

const getSpecialOptions = (state, options) => {
    Object.entries(options).forEach(([key, v]) => {
        const relations = filterSpecialChannelProjects(state, v)
        if (Object.keys(relations).length === 0) {
            delete options[key]
        }
    })

    return options
}

const filterSpecialChannelProjects = (state, channel) => {
    const relations = {}
    // const projects = {}
    // channel = cloneDeep(channel)
    //
    // console.log('filterSpecialChannelProjects', channel)

    Object.entries(channel.salesforceRelations).forEach(([relKey, relValue]) => {
        if (Object.keys(relValue.projectOptions).length > 0) {
            relations[relKey] = relValue
        }
        // Object.entries(relValue.projectOptions).forEach(([projKey, projValue]) => {
        //     projects[projKey] = projValue
        // })
        //
        // if (Object.keys(projects).length > 0) {
        //     relValue.projectOptions = projects
        //     relations[relKey] = relValue
        // }
    })
    return relations
}

export const getSubchannelOptionsV3 = (state, channel) => {
    if (!channel) {
        return {}
    }
    return getChannelOptionsV3(state)[channel].subchannels
}

export const getTypologyOptionsV3 = (state) => {
    if (state.segmentation.channel === 'nexus' || state.segmentation.channel === 'nexus_retail' || state.segmentation.channel === 'nexus_non_retail') {
        const ambiances = new Set()
        state.segmentation.materials.forEach(m => {
            if (m.material == state.segmentation.segmentatingProductId && (!state.segmentation.projectId || m.projectId == state.segmentation.projectId)) {
                ambiances.add(m.ambient)
            }
        })
        return state.segmentation.typologiesV3.filter(t => ambiances.has(t.id))
    }
    return state.segmentation.typologiesV3
}

export const getSalesforceRelationsV3 = (state, inProfile = false) => {

    let channel = state.segmentation.channel

    if (channel === 'nexus' || channel === 'nexus_retail' || channel === 'nexus_non_retail') {
        const nexusOptions = inProfile 
            ? (state.segmentation && state.segmentation.nexusOptions && state.segmentation.nexusOptions[channel])
            : (getNexusOptions(state) && getNexusOptions(state)[channel])

        return nexusOptions && nexusOptions.salesforceRelations ? nexusOptions.salesforceRelations : {}
    }

    if (channel === 'leads' || channel === 'leads_retail' || channel === 'leads_non_retail') {
        const leadsB2COptions = inProfile
            ? (state.segmentation && state.segmentation.leadsB2COptions && state.segmentation.leadsB2COptions[channel])
            : (getLeadsB2COptions(state) && getLeadsB2COptions(state)[channel])

        return leadsB2COptions && leadsB2COptions.salesforceRelations ? leadsB2COptions.salesforceRelations : {}
    }

    const channelOptions = getChannelOptionsV3(state)
    if (channel === 'PO') channel = state.segmentation.originalChannel
    return channelOptions && channelOptions[channel] && channelOptions[channel].salesforceRelations
        ? channelOptions[channel].salesforceRelations
        : {}
}

export const getEvidencesType = (state) => {
    let evidenceType = null
    if (state.segmentation.salesForceId) {
        const sfOptions = getSalesforceRelationsV3(state)
        const sfOption = sfOptions[state.segmentation.salesForceId]
        if (sfOption) {
            const projectId = state.segmentation.projectId ? state.segmentation.projectId : ""
            const project = sfOption.projectOptions && sfOption.projectOptions[projectId]
            if (project) evidenceType = project.evidences
        }
    }
    return evidenceType
}

export const getProjectIdV3 = (state, channel, salesForceId, inProfile=false) => {

    if (channel === 'PO'
        || channel === 'AP'
        || channel === 'B0'
        || channel === 'HE'
        || channel === 'HO'
        || channel === 'nexus'
        || channel === 'nexus_retail'
        || channel === 'nexus_non_retail'
        || channel === 'leads'
        || channel === 'leads_retail'
        || channel === 'leads_non_retail'
    ) {
        function mapChannel(channelOptions, projectOptions, originalChannel) {
            if (channelOptions) {
                const salesForceRelations = Object.entries(channelOptions.salesforceRelations)
                salesForceRelations.map(([salesForceId, relation]) => {

                    Object.values(relation.projectOptions).map(eachProject => {
                        projectOptions[eachProject.projectId] = {
                            projectId: eachProject.projectId,
                            projectName: eachProject.projectName,
                            subchannelProgram: eachProject.subchannelProgram,
                            businessSegment: relation.businessSegment,
                            subchannelId: eachProject.subchannelId,
                            originalChannel: originalChannel ? originalChannel : eachProject.originalChannel,
                            originalChannelName: relation.originalChannelName ? relation.originalChannelName : (channel ? channelOptions.name : null),
                            salesForceId: salesForceId,
                            salesForceName: relation.name
                        }
                    })


                })
            }
        }

        let projectOptions = []

        if (channel === 'PO') {
            const APchannelOptions = state.segmentation.segmentationOptions['AP']
            const B0channelOptions = state.segmentation.segmentationOptions['B0']
            const HEchannelOptions = state.segmentation.segmentationOptions['HE']
            if (B0channelOptions) mapChannel(B0channelOptions, projectOptions, 'B0')
            if (HEchannelOptions) mapChannel(HEchannelOptions, projectOptions, 'HE')
            if (APchannelOptions) mapChannel(APchannelOptions, projectOptions, 'A0')
        } else if (channel.startsWith('nexus')) {
            const nexusOptions = {...state.segmentation.nexusOptions.nexus_retail, ...state.segmentation.nexusOptions.nexus_non_retail}
            mapChannel(inProfile ? state.segmentation.nexusOptions[channel] : getNexusOptions(state)[channel], projectOptions)
            // mapChannel(inProfile ? state.segmentation.nexusOptions[channel] : getNexusOptions(state)[channel], projectOptions)
        } else if (channel.startsWith('leads')) {
            mapChannel(inProfile ? state.segmentation.leadsB2COptions[channel] : getLeadsB2COptions(state)[channel], projectOptions)
        } else {
            mapChannel(state.segmentation.segmentationOptions['HO'], projectOptions)
        }

        projectOptions = Object.fromEntries(Object.entries(projectOptions.sort()).filter(([key, _]) => !!key));
        return projectOptions
    }

    if (!salesForceId) {
        return {}
    }

    if (!getChannelOptionsV3(state)[channel].salesforceRelations[salesForceId]) {
        return {}
    }

    return getChannelOptionsV3(state)[channel].salesforceRelations[salesForceId].projectOptions
}

export const getBusinesSegmentOptions = state => {
    return state.segmentation.segmentationOptions
}
export const getChannelOptions = (state, businessSegment) => {
    if (!businessSegment) {
        return {}
    }
    if (!state.segmentation.segmentationOptions[businessSegment]) {
        return {}
    }
    return state.segmentation.segmentationOptions[businessSegment].channels
}

export const getSubchannelOptions = (state, businessSegment, channel) => {
    if (!channel) {
        return {}
    }
    return getChannelOptions(state, businessSegment)[channel].subchannels
}

export const getTypologyOptions = (state, businessSegment, channel, subchannel) => {
    if (!subchannel) {
        return {}
    }
    return getSubchannelOptions(state, businessSegment, channel)[subchannel].typologies
}

export const getUseOptions = state => {
    if (state.segmentation.channel === 'nexus' || state.segmentation.channel === 'nexus_retail' || state.segmentation.channel === 'nexus_non_retail') {
        const uses = new Set()
        state.segmentation.materials.forEach(m => {
            if (m.material == state.segmentation.segmentatingProductId && (!state.segmentation.projectId || m.projectId == state.segmentation.projectId)) {
                uses.add(m.use)
            }
        })
        return state.segmentation.useOptions.filter(t => uses.has(t.id))
    }
    return state.segmentation.useOptions
}
export const getKBOptions = state => {
    return state.segmentation.kbOptions
}
export const getBuildersOptions = state => {
    return state.segmentation.buildersOptions
}
export const getSelectedBusinesSegment = state => {
    return state.segmentation.businessSegment
}
export const getSelectedChannel = state => {
    return state.segmentation.channel
}
export const getSelectedOriginalChannel = state => {
    return state.segmentation.originalChannel
}
export const getSelectedChannelName = state => {
    return state.segmentation.channelName
}
export const getSelectedOriginalChannelName = state => {
    return state.segmentation.originalChannelName
}
export const getSelectedSalesForceId = state => {
    return state.segmentation.salesForceId
}
export const getSelectedProjectId = state => {
    return state.segmentation.projectId
}
export const getSelectedProjectName = state => {
    return state.segmentation.projectName
}
export const getSelectedSalesForceName = state => {
    return state.segmentation.salesForceName
}
export const getSelectedSubchannelProgram = state => {
    return state.segmentation.subchannelProgram
}
export const getSelectedSubchannel = state => {
    return state.segmentation.subchannel
}
export const getSelectedSubchannelName = state => {
    return state.segmentation.subchannelName
}
export const getSelectedTypology = state => {
    return state.segmentation.typology
}
export const getSelectedTypologyName = state => {
    return state.segmentation.typologyName
}
export const getSelectedUse = state => {
    return state.segmentation.use
}
export const getSelectedUseName = state => {
    return state.segmentation.useName
}
export const getSelectedKB = state => {
    return state.segmentation.kb
}
export const getSelectedBuilder = state => {
    return state.segmentation.builder
}
export const getPO = state => {
    return state.segmentation.po
}
export const segmentationDone = state => {
    return state.segmentation.segmentationSubmitted
}
export const getCurrentSegmentation = state => {
    return state.segmentation.currentSegmentation
}
export const getCurrentFavourite = state => {
    return state.segmentation.currentFavourite
}
export const getPreferredSegmentation = state => {
    return state.segmentation.preferredSegmentation
    // const preferredSegmentation = []
    //
    // if (Array.isArray(state.segmentation.preferredSegmentation)) {
    //     state.segmentation.preferredSegmentation.forEach((v) => {
    //         if (v.channel && (!v.channel.startsWith('nexus') || getNexusOptions(state)[v.channel])) {
    //             preferredSegmentation.push(v)
    //         }
    //     })
    // }
    // return preferredSegmentation
}
export const getPreferredSegmentationByName = (state, name) => {
    return getPreferredSegmentation(state).find(segmentation => {
        return segmentation.name === name
    })
}
export const getIsSaving = state => {
    return state.segmentation.isSaving
}
export const getIsLoading = state => {
    return state.segmentation.fetchingSegmentation
}
export const getHasSegmentationV3 = state => {
    if (!getIsLogged(state)) return false
    return state.segmentation.segmentationV3
}

export const getFullSelectedSegmentation = state => {

    const selectedKB = getSelectedKB(state)
    const selectedBuilder = getSelectedBuilder(state)

    const originalChannel = getSelectedOriginalChannel(state)
    const originalChannelName = getSelectedOriginalChannelName(state)

    return {
        businessSegment: getSelectedBusinesSegment(state) === 'NOT' ? null : getSelectedBusinesSegment(state),
        channel: getSelectedChannel(state),
        originalChannel: originalChannel,
        channelName: originalChannelName ? originalChannelName : getSelectedChannelName(state),
        subchannel: getSelectedSubchannel(state),
        subchannelName: getSelectedSubchannelName(state),

        salesforceId: getSelectedSalesForceId(state),
        salesforceName: getSelectedSalesForceName(state),

        projectId: getSelectedProjectId(state),
        projectName: getSelectedProjectName(state),

        subchannelProgram: getSelectedSubchannelProgram(state) ? getSelectedSubchannelProgram(state) : null,

        typology: getSelectedTypology(state),
        typologyName: getSelectedTypologyName(state),

        use: getSelectedUse(state),
        useName: getSelectedUseName(state),

        kbId: selectedKB ? selectedKB.id : null,
        kbName: selectedKB ? selectedKB.name : null,
        builderId: selectedBuilder ? selectedBuilder.id : null,
        builderName: selectedBuilder ? selectedBuilder.name : null,
        purchaseOrders: getPO(state),
        segmentationEvidences: getSegmentationEvidence(state)
    }
}
export const getChannelNameById = (state, channel) => {
    return getChannelOptionsV3(state)[channel]
}
export const getSubchannelNameById = (state, channel, subchannel) => {
    return getSubchannelOptionsV3(state, channel)[subchannel]
}
export const getSegmentatingProductId = state => {
    return state.segmentation.segmentatingProductId
}
export const getSegmentatingProductIsOutlet = state => {
    return state.segmentation.segmentatingProductIsOutlet
}
export const validHomeDepotSegmentation = state => {
    if (getSelectedSubchannelProgram(state) === 'D000000001' && getSelectedChannel(state) === 'D0') return true
    if (getSelectedSubchannel(state) === '4A' && getSelectedChannel(state) === 'D0') return true
    return false
}

export const getSegmentationCurrentStep = state => {
    return state.segmentation.segmentationCurrentStep
}

export default segmentation

export const getNexusEnvironment = state => {
    if (!state.login.impersonatedBy && (state.segmentation.channel === 'nexus' || state.segmentation.channel === 'nexus_retail' || state.segmentation.channel === 'nexus_non_retail')) {
        const environments = getTypologyOptionsV3(state)
        if (environments.length === 1) return environments[0]
        else return {
            id:"KI",
            name:"KITCHEN"
        }
    }
    return null
}

export const getNexusUse = state => {
    if (!state.login.impersonatedBy && (state.segmentation.channel === 'nexus' || state.segmentation.channel === 'nexus_retail' || state.segmentation.channel === 'nexus_non_retail')) {
        const uses = getUseOptions(state)
        if (uses.length === 1) return uses[0]
        else return {
            id:"10",
            name:"Kitchen Countertops"
        }
    }
    return null
}

export const getSegmentationEvidence = state => {
    return state.segmentation.segmentationEvidence
}

export const getSuggestedSegmentations = state => {
    // return Object.values(state.segmentation.suggestedSegmentations).map(v => v[0]).slice(0,5)
    return (state.segmentation.suggestedSegmentations && state.segmentation.suggestedSegmentations[state.segmentation.segmentatingProductId]) ?
        state.segmentation.suggestedSegmentations[state.segmentation.segmentatingProductId].slice(0, 5) : []
}

export const getMaterialProjects = (state) => {
    const projects = state.segmentation.materials.filter(m => m.material == state.segmentation.segmentatingProductId).map(m => m.projectId)
    return new Set(projects)
}

export const getSegmentationHashes = state => state.segmentation.segmentationHashesSet
export const getSegmentationProjects = state => state.segmentation.segmentationProjectsSet